module.exports = __webpack_public_path__ + "static/img/pic-faq1.6393073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-faq1.png
// module id = 935
// module chunks = 0